import { useAppSelector } from 'hooks/redux'

/**
 * Returns whether the current user is a superadmin LAB user.
 *
 * Superadmin gates LAB-user management (add/edit/delete LAB users, granting
 * superadmin) and DME office deletion. The backend re-checks this against the
 * persisted flag, so this hook is only used to drive the UI.
 */
export function useIsSuperadmin(): boolean {
  return useAppSelector((state) => state.init.isSuperadmin === true)
}
